import { render } from "./MdRadio.vue?vue&type=template&id=12d1f6a7"
import script from "./MdRadio.vue?vue&type=script&lang=js"
export * from "./MdRadio.vue?vue&type=script&lang=js"

import "./MdRadio.vue?vue&type=style&index=0&id=12d1f6a7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__